/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-02-16 08:21:40
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import AttributesTable from 'src/components/views/merchandising-v2/rule/strategy/banners/attributes-table';

type Props = {
  fields: any,
  type: String,
  strategies: Array<{
    type: String,
    attributes?: Array<Object>,
    position: Number,
    imgSrc: File | Object,
    name: String,
    link: String,
    openInNewTab: Boolean
  }>,
  selectedIndex: Number,
  maxCondition: Number,
  updateField: Function
};

type ComposedProps = Props & WithI18nProps;

const BannerSettings = (props: ComposedProps) => {
  const { fields, type, strategies, selectedIndex, updateField, mainTheme, formValues } = props;


  // const removeSet = index => {
  //   fields.remove(index);
  // };

  // Render rows for data table
  const buildRows = () => {
    const filterStrategyByType = strategies.filter(e => e.type === type);
    // let countField = 0;
    const rows = fields.map((condition, index) => {
      // Get product attribute
      const isSelected = selectedIndex === JSON.stringify(strategies[index]);

      if (
        _.get(strategies, `[${index}].type`, '') === type ||
        _.isEmpty(_.get(strategies, `[${index}].type`, ''))
      ) {
        // countField++;
        return (
          <div className="banner-group-settings" key={`banner-setting-${index}`}>
            <div
              className="card-section"
              style={{
                backgroundColor: `${isSelected ? '#F6F6F7' : '#FFFFFF'}`
              }}
              key={index}>
              {/* <div className="banner-title">
                <div className="title">
                  <div className="group-number">{countField}</div>
                  <TextStyle variation="subdued">
                    <span style={{ textTransform: 'uppercase' }}>
                      {i18n.translate('AdminHTML.MerchandisingV2.BannerSettings.titleNumber', {
                        number: countField
                      })}
                    </span>
                  </TextStyle>
                </div>
                {filterStrategyByType.length > 1 ? (
                  <Button icon={DeleteMinor} plain onClick={() => removeSet(index)}></Button>
                ) : (
                  ''
                )}
              </div> */}
              <AttributesTable
                settings={filterStrategyByType}
                item={`strategies[${index}]`}
                strategies={strategies}
                indexStrategy={index}
                mainTheme={mainTheme}
                formValues={formValues}
                updateField={updateField}
              />
            </div>
          </div>
        );
      }
      return null;
    });

    return rows;
  };

  const rowConditions = buildRows();
  return <div>{rowConditions.map(row => row)}</div>;
};

export default withI18n()(BannerSettings);
